/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementInstanceBase,
  AgreementInstanceBaseOptional,
  AgreementInstanceBaseMetaI,
  AgreementInstanceBaseTrackedI,
} from "./agreement-instance-base";
import {
  AgreementInstanceBaseTracked,
  AgreementInstanceBaseMeta,
} from "./agreement-instance-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementInstanceRef,
  AgreementInstanceRefOptional,
  AgreementInstanceRefMetaI,
  AgreementInstanceRefTrackedI,
} from "./agreement-instance-ref";
import {
  AgreementInstanceRefTracked,
  AgreementInstanceRefMeta,
} from "./agreement-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";

/**
 *
 * @export
 * @interface AgreementInstanceFull
 */
export interface AgreementInstanceFullOptional extends AgreementInstanceBaseOptional {
  /**
   *
   * @type {number}
   * @memberof AgreementInstanceFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  endActive?: Date;
  /**
   *
   * @type {number}
   * @memberof AgreementInstanceFull
   */
  agreementVersion?: number;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  agreementText?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  agreementHeader?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  agreementAgreeText?: string;
  /**
   *
   * @type {boolean}
   * @memberof AgreementInstanceFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementInstanceFull
   */
  isNew?: boolean;
}

export interface AgreementInstanceFull
  extends
    AgreementInstanceFullOptional,
    AgreementInstanceBase,
    AgreementInstanceRef,
    Deletable {
  /**
   *
   * @type {number}
   * @memberof AgreementInstanceFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  endActive?: Date;
  /**
   *
   * @type {number}
   * @memberof AgreementInstanceFull
   */
  agreementVersion?: number;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  agreementText?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  agreementHeader?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  agreementAgreeText?: string;
  /**
   *
   * @type {boolean}
   * @memberof AgreementInstanceFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementInstanceFull
   */
  isNew?: boolean;
}

export interface AgreementInstanceFullTrackedI extends AgreementInstanceBaseOptional {
  /**
   *
   * @type {number}
   * @memberof AgreementInstanceFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementInstanceFull
   */
  agreementVersion?: number;
  agreementVersionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  agreementText?: string;
  agreementTextIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  agreementHeader?: string;
  agreementHeaderIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceFull
   */
  agreementAgreeText?: string;
  agreementAgreeTextIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementInstanceFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementInstanceFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
}

transformDatesMap.set(
  "AgreementInstanceFull",
  function (model: AgreementInstanceFull) {
    if (typeof model.startActive == "string")
      model.startActive = new Date(model.startActive);
    if (typeof model.endActive == "string")
      model.endActive = new Date(model.endActive);
  },
);

export type AgreementInstanceFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  agreementVersion: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  agreementText: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  agreementHeader: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  agreementAgreeText: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var AgreementInstanceFullMeta: AgreementInstanceFullMetaI =
  {} as AgreementInstanceFullMetaI;
AgreementInstanceFullMeta = typeMeta("AgreementInstanceFull", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  agreementVersion: propertyMeta(
    "agreementVersion",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  agreementText: propertyMeta(
    "agreementText",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  agreementHeader: propertyMeta(
    "agreementHeader",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  agreementAgreeText: propertyMeta(
    "agreementAgreeText",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
});

const metaI = AgreementInstanceFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([AgreementInstanceRefMeta]);
  metaI.assignId.inheritedFrom = AgreementInstanceRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([AgreementInstanceBaseMeta]);
  metaI.startActive.inheritedFrom = AgreementInstanceBaseMeta.startActive;
  metaI.endActive.inheritedFrom = AgreementInstanceBaseMeta.endActive;
  metaI.agreementVersion.inheritedFrom =
    AgreementInstanceBaseMeta.agreementVersion;
  metaI.agreementText.inheritedFrom = AgreementInstanceBaseMeta.agreementText;
  metaI.agreementHeader.inheritedFrom =
    AgreementInstanceBaseMeta.agreementHeader;
  metaI.agreementAgreeText.inheritedFrom =
    AgreementInstanceBaseMeta.agreementAgreeText;
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
});

export class AgreementInstanceFullTracked
  extends AgreementInstanceBaseTracked
  implements AgreementInstanceFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  agreementVersion__I?: number = undefined;
  agreementVersionIsSet: boolean = false;
  set agreementVersion(v: undefined | number) {
    if (v !== undefined) {
      this.agreementVersion__I = v;
      this.agreementVersionIsSet = true;
    } else {
      this.agreementVersion__I = v || undefined;
      this.agreementVersionIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementVersion() {
    return this.agreementVersion__I;
  }
  agreementText__I?: string = undefined;
  agreementTextIsSet: boolean = false;
  set agreementText(v: undefined | string) {
    if (v !== undefined) {
      this.agreementText__I = v;
      this.agreementTextIsSet = true;
    } else {
      this.agreementText__I = v || undefined;
      this.agreementTextIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementText() {
    return this.agreementText__I;
  }
  agreementHeader__I?: string = undefined;
  agreementHeaderIsSet: boolean = false;
  set agreementHeader(v: undefined | string) {
    if (v !== undefined) {
      this.agreementHeader__I = v;
      this.agreementHeaderIsSet = true;
    } else {
      this.agreementHeader__I = v || undefined;
      this.agreementHeaderIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementHeader() {
    return this.agreementHeader__I;
  }
  agreementAgreeText__I?: string = undefined;
  agreementAgreeTextIsSet: boolean = false;
  set agreementAgreeText(v: undefined | string) {
    if (v !== undefined) {
      this.agreementAgreeText__I = v;
      this.agreementAgreeTextIsSet = true;
    } else {
      this.agreementAgreeText__I = v || undefined;
      this.agreementAgreeTextIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementAgreeText() {
    return this.agreementAgreeText__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  constructor(config?: AgreementInstanceFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: AgreementInstanceFullOptional,
    options?: AssignOptions,
  ): AgreementInstanceFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (
      config.agreementVersion &&
      this.agreementVersionApplyFilter(optionsRequired.filter)
    ) {
      this.agreementVersion = config.agreementVersion;
      if (optionsRequired.unassign) this.agreementVersionIsSet = false;
      else this.agreementVersionIsSet = true;
    }
    if (
      config.agreementText &&
      this.agreementTextApplyFilter(optionsRequired.filter)
    ) {
      this.agreementText = config.agreementText;
      if (optionsRequired.unassign) this.agreementTextIsSet = false;
      else this.agreementTextIsSet = true;
    }
    if (
      config.agreementHeader &&
      this.agreementHeaderApplyFilter(optionsRequired.filter)
    ) {
      this.agreementHeader = config.agreementHeader;
      if (optionsRequired.unassign) this.agreementHeaderIsSet = false;
      else this.agreementHeaderIsSet = true;
    }
    if (
      config.agreementAgreeText &&
      this.agreementAgreeTextApplyFilter(optionsRequired.filter)
    ) {
      this.agreementAgreeText = config.agreementAgreeText;
      if (optionsRequired.unassign) this.agreementAgreeTextIsSet = false;
      else this.agreementAgreeTextIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): AgreementInstanceFullTrackedI {
    const cloned = {} as AgreementInstanceFullTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.agreementVersionIsSetDeep() &&
      this.agreementVersionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementVersionIsSet = true;
      cloned.agreementVersion = this.agreementVersion;
    } else {
      //cloned.agreementVersionIsSet = false
    }
    if (
      this.agreementTextIsSetDeep() &&
      this.agreementTextApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementTextIsSet = true;
      cloned.agreementText = this.agreementText;
    } else {
      //cloned.agreementTextIsSet = false
    }
    if (
      this.agreementHeaderIsSetDeep() &&
      this.agreementHeaderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementHeaderIsSet = true;
      cloned.agreementHeader = this.agreementHeader;
    } else {
      //cloned.agreementHeaderIsSet = false
    }
    if (
      this.agreementAgreeTextIsSetDeep() &&
      this.agreementAgreeTextApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementAgreeTextIsSet = true;
      cloned.agreementAgreeText = this.agreementAgreeText;
    } else {
      //cloned.agreementAgreeTextIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): AgreementInstanceFullTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.agreementVersionApplyFilter(filter))
      this.agreementVersionIsSet = false;

    if (!this.agreementTextApplyFilter(filter)) this.agreementTextIsSet = false;

    if (!this.agreementHeaderApplyFilter(filter))
      this.agreementHeaderIsSet = false;

    if (!this.agreementAgreeTextApplyFilter(filter))
      this.agreementAgreeTextIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceFullMeta.assignId,
      AgreementInstanceFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceFullMeta.startActive,
      AgreementInstanceFullMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceFullMeta.endActive,
      AgreementInstanceFullMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  agreementVersionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceFullMeta.agreementVersion,
      AgreementInstanceFullMeta,
      this.agreementVersion,
      this,
    );
  }
  agreementVersionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementVersionIsSet && this.agreementVersionApplyFilter(filter))
      return true;

    return false;
  }
  agreementTextApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceFullMeta.agreementText,
      AgreementInstanceFullMeta,
      this.agreementText,
      this,
    );
  }
  agreementTextIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementTextIsSet && this.agreementTextApplyFilter(filter))
      return true;

    return false;
  }
  agreementHeaderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceFullMeta.agreementHeader,
      AgreementInstanceFullMeta,
      this.agreementHeader,
      this,
    );
  }
  agreementHeaderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementHeaderIsSet && this.agreementHeaderApplyFilter(filter))
      return true;

    return false;
  }
  agreementAgreeTextApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceFullMeta.agreementAgreeText,
      AgreementInstanceFullMeta,
      this.agreementAgreeText,
      this,
    );
  }
  agreementAgreeTextIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.agreementAgreeTextIsSet &&
      this.agreementAgreeTextApplyFilter(filter)
    )
      return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceFullMeta.isDeleted,
      AgreementInstanceFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceFullMeta.isNew,
      AgreementInstanceFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.agreementVersionIsSetDeep(filter)) return true;
    if (this.agreementTextIsSetDeep(filter)) return true;
    if (this.agreementHeaderIsSetDeep(filter)) return true;
    if (this.agreementAgreeTextIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
